// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d5d2656d","453":"21c0088b","732":"ba99e62a"}[chunkId] + ".chunk.js";
};